import comp from "./SharedWith.js";
export default comp;
